import { StorageManager } from '@speeki/storage-manager';

import { UserOptionsDocument } from '@graphql/generated/graphql';

import { useQuery, useReactiveVar } from '@apollo/client';
import { authVar } from '@boot/reactiveVariables';

export const useUserOptions = () => {
    const mfaMetadata = StorageManager.getValue('metadata');
    const isLoggedIn = useReactiveVar(authVar).isLoggedIn;

    return useQuery(UserOptionsDocument, {
        context: {
            logoutOnError: true,
        },
        skip: !isLoggedIn || !!mfaMetadata,
    });
};
